import { closeWorkingOrder } from "actions/working-order-state";
import { getStore } from "store";

export default function (currState, nextState) {
    const currLocation = currState.location || { pathname: "" };
    const nextLocation = nextState.location || { pathname: "" };

    if (currLocation.pathname.includes("/cart") && !nextLocation.pathname.includes("/cart")) {
        getStore().dispatch(closeWorkingOrder({ brandChanged: currState.params.brand !== nextState.params.brand }));
    }
}
